<template>
  <div class="AdminUser">
    <AdminUsersHeader @onChangeTab="onChangeTab" />
    <transition name="fade">
      <AdminUsersTable v-if="!isLoading" ref="userTable" />
    </transition>
  </div>
</template>

<script>
import AdminUsersHeader from "@/views/admin/AdminUsersHeader.module.vue";
import AdminUsersTable from "@/views/admin/AdminUsersTable.module.vue";
import { setTimeout } from "timers";

export default {
  components: {
    AdminUsersHeader,
    AdminUsersTable,
  },
  data () {
    return {
      isLoading: false,
    };
  },
  methods: {
    async onChangeTab () {
      this.isLoading = true;
      await this.$refs.userTable.update();
      setTimeout(() => {
        this.isLoading = false;
      }, 300);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/variables.scss";

.AdminUser {
  width: 99%;
  margin-left: 0.7rem;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
